import React, { useState } from 'react';
import { MoreVert, Edit, Archive, Unarchive, InfoOutlined, CopyAll } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, Typography, Tooltip, Switch, Divider } from '@mui/material';

export const AssessmentMenu = ({ assessment, onEdit, onArchive, onClone, onTestModeToggle }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        onEdit(assessment.id);
        handleClose();
    };

    const handleArchive = () => {
        onArchive(assessment.id);
        handleClose();
    };

    const handleClone = () => {
        onClone(assessment.id);
        handleClose();
    };

    const getMenuMessage = (status) => {
        switch (status) {
            case 'live':
                return 'Live assessments cannot be edited. Clone them to create an editable copy.'
            case 'archived':
                return 'Archived assessments can be cloned to create an editable copy.'
            default:
                return ''
        }
    }

    return (
        <>
            <Tooltip title="Options" placement="top">
                <span>
                    <IconButton
                        aria-label="more"
                        aria-controls="assessment-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        size="small"
                        sx={{
                            '&:hover': {
                                color: '#1450a0',
                                backgroundColor: 'rgba(20, 80, 160, 0.1)', // Light blue background on hover
                            },
                            transition: 'color 0.3s ease',
                        }}
                    >
                        <MoreVert />
                    </IconButton>
                </span>
            </Tooltip>
            <Menu
                id="assessment-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        width: '250px',
                        padding: '8px 0',
                        borderRadius: '8px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleEdit} disabled={['archived', 'live', 'closed'].includes(assessment.status)} style={{ display: 'flex', alignItems: 'center', color: '#1450a0' }}>
                    <Edit fontSize="small" style={{ marginRight: '0.5em' }} />
                    Edit
                </MenuItem>
                <MenuItem onClick={handleArchive} disabled={assessment.status === 'archived'} style={{ display: 'flex', alignItems: 'center', color: '#1450a0' }}>
                    <Archive fontSize="small" style={{ marginRight: '0.5em' }} />
                    Archive
                </MenuItem>
                <MenuItem onClick={handleClone} style={{ display: 'flex', alignItems: 'center', color: '#1450a0' }}>
                    <CopyAll fontSize="small" style={{ marginRight: '0.5em' }} />
                    Clone
                </MenuItem>
                {/* Divider before Test Mode Switch */}
                <Divider style={{ margin: '8px 0' }} />

                {/* Test Mode Toggle Switch */}
                <MenuItem
                    onClick={assessment.status === 'published'
                        ? () => onTestModeToggle(!assessment.is_test_mode, assessment.id)
                        : undefined
                    }
                    disabled={assessment.status !== 'published'}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ color: '#1450a0', fontSize: '0.9em' }}>Test Mode</span>
                    <Switch
                        size="small"
                        checked={!!assessment?.is_test_mode}
                        onChange={(e) => onTestModeToggle(e.target.checked, assessment.id)}
                        color="primary"
                        onClick={(e) => e.stopPropagation()}
                    />
                </MenuItem>
                <Typography
                    variant="caption"
                    component="p"
                    style={{
                        paddingLeft: '1.5em',
                        paddingRight: '1em',
                        color: '#666',
                        fontSize: '0.75em',
                        marginTop: '0.5em',
                        fontStyle: 'italic'
                    }}
                >
                    {getMenuMessage(assessment.status)}
                </Typography>
            </Menu>
        </>
    );
};
